var _circle, _circle2, _circle3, _circle4, _rect, _circle5, _circle6, _circle7, _circle8, _rect2, _circle9, _circle0, _circle1, _circle10, _rect3, _circle11, _circle12, _circle13, _circle14, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentGroupsTypeNewGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.23318,
    cy: 4.92633,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0514,
    cy: 4.92633,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.23336,
    cy: 20.7444,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0514,
    cy: 20.7444,
    r: 3.95453,
    fill: "#30B36B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.6044,
    y: 5.29735,
    width: 15.0764,
    height: 15.0764,
    stroke: "#30B36B",
    strokeWidth: 0.741667
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.23336,
    cy: 39.1988,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0516,
    cy: 39.1988,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.23352,
    cy: 55.0168,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0516,
    cy: 55.0168,
    r: 3.95453,
    fill: "#30B36B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.60457,
    y: 39.5697,
    width: 15.0764,
    height: 15.0764,
    stroke: "#30B36B",
    strokeWidth: 0.741667
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5058,
    cy: 4.92633,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.3241,
    cy: 4.92633,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5059,
    cy: 20.7444,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.3241,
    cy: 20.7444,
    r: 3.95453,
    fill: "#30B36B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8768,
    y: 5.29735,
    width: 15.0764,
    height: 15.0764,
    stroke: "#30B36B",
    strokeWidth: 0.741667
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5058,
    cy: 39.1988,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.3241,
    cy: 39.1988,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5059,
    cy: 55.0168,
    r: 3.95453,
    fill: "#30B36B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.3241,
    cy: 55.0168,
    r: 3.95453,
    fill: "#30B36B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8768,
    y: 39.5697,
    width: 15.0764,
    height: 15.0764,
    stroke: "#30B36B",
    strokeWidth: 0.741667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentGroupsTypeNewGreen);
export default __webpack_public_path__ + "static/media/tournament-groups-type-new-green.f9226f7343cddcd374edfeab37b4460b.svg";
export { ForwardRef as ReactComponent };